/*jslint node: true*/
"use strict";

var ko = require("pli/knockout");
var pli = require("pli/forms");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Comment Delete Form class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
// View model for comment delete confirmation dialog
function CommentDeleteForm(form) {

    if (!form) { throw new Error("Comment delete form is not defined"); }

    this.form = form;
    this.open = CommentDeleteForm.prototype.open.bind(this);
}


//-------------------------------------------
// Opens the comment delete confirmation dialog
CommentDeleteForm.prototype.open = function open(deleteComment) {
    if (typeof deleteComment !== "function") { throw new Error("deleteComment should be function"); }

    this._deleteComment = deleteComment;

    // bind the form if it is not already
    if (!this.isBound) {
        ko.applyBindings(this, this.form.$form[0]);
        this.isBound = true;
    }

    // show the inline form
    pli.forms.open(this.form.id);

    return false; // prevent default behaviour
};

//---------------------------------------
CommentDeleteForm.prototype.cancel = function cancel() {
    this.form.close();
};

//---------------------------------------
CommentDeleteForm.prototype.deleteConfirm = function deleteConfirm() {
    this.form.close();
    this._deleteComment();
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
// Get delete comment form
var deleteForm = pli.forms.registry.deleteCommentForm;
if (!deleteForm) {
    throw new Error("Comment delete form is not found. Did you create it with CreateCommentDeleteConfirmationForm() method?");
}

// Create and set viewModel
if (!deleteForm.viewModel) {
    deleteForm.viewModel = new CommentDeleteForm(deleteForm);
    deleteForm.open = deleteForm.viewModel.open;
}


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
module.exports = CommentDeleteForm;



//////////////////
// WEBPACK FOOTER
// ./app/document/commentDeleteForm.js
// module id = 566
// module chunks = 49